'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */
var ColidoLayoutView = require('base/Colido.LayoutView');
var UploadComponent = require('modules/settings/views/partials/profile/upload.js');
var template = require('modules/settings/templates/partials/profile/logo.hbs');

var LogoUploadView = ColidoLayoutView.extend({
    template: template,
    wrapItem: false,

    imageUploadComponent: null,
    imageId: null,
    imageUrl: null,
    imageCrop: false,
    imageStream: false,

    ui: {
        'imageUploadTrigger': '[data-action="trigger-upload"]',
        'imagePreviewContent': '.image-preview-content',
        'imageDelete': '[data-action="delete-image"]',
        'imageId': '[name="imageId"]',
        'imageUploadComponentRegion': '.profile-logo-upload-region',
    },

    events: {
        'click @ui.imageDelete': 'onImageDelete',
    },

    regions: {
        'imageUploadComponentRegion': '.image-upload-region',
    },

    childEvents: {
        'upload:state:finished': 'onImageChanged',
    },

    modelEvents: {
        'change sync': 'render',
    },

    onRender: function() {
        this.imageUploadComponent = new UploadComponent({});
        this.imageUploadComponentRegion.show(this.imageUploadComponent);

        if (this.model.get('profileLogoUrl')) {
            this.onImageChanged(null, this.model.get('profileLogoUrl'));
        } else {
            this._setImage(null);
        }

        this.ui.imageUploadTrigger.attr('for', 'input-file-upload-' + this.imageUploadComponent.fileSelectView.cid);
    },

    onImageDelete: function(event) {
        event.preventDefault();

        this._setImage(false);
        this.triggerMethod('profile:changed');
    },

    onImageChanged: function(event, data) {
        // TODO: the resolution may have to be dynamic
        var image = data.baseUrl + '300x300/' + data.fileName;

        this._setImage(data.id, image);
    },

    /**
     * @param id number id des assets
     * @param url string vollständige url zum asset
     * @private
     */
    _setImage: function(id, url) {
        if (id && url) {
            this.ui.imageUploadTrigger.addClass('hidden');
            this.ui.imageDelete.show();

            this.ui.imagePreviewContent.find('img').remove();
            this.ui.imageId.val(id);
            if (this.imageCrop) {
                this.ui.imagePreviewContent.css({
                    'background-image': 'url(' + url + ')',
                }).show();
            } else {
                var img = $('<img>').attr('src', url);
                this.ui.imagePreviewContent.show().append(img);
            }
            this.imageId = id;
            this.imageUrl = url;
        } else {
            this.ui.imageUploadTrigger.removeClass('hidden');
            this.ui.imageDelete.hide();

            this.ui.imageId.val(-1);
            this.ui.imagePreviewContent.css({
                'background-image': 'none',
            }).hide();
            this.imageId = null;
            this.imageUrl = null;
        }
    },
});

module.exports = LogoUploadView;